module.exports = "<div class=\"container-fluid d-flex flex-column justify-content-center align-items-center\">\n  <h3>We are building new tools for you.</h3>\n  <p>Trade and connect with your partners.<br>Check partners details, protocols and much more.</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/partners/partners.component.html
// module id = ./src/app/manage/partners/partners.component.html
// module chunks = main